import { Injectable } from '@angular/core';

@Injectable()
export class FilterUtilService {
  constructor() {}

  searchFilter() {
    return 'searchFilterWorked';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/filter-util.service.ts